import React from 'react';
import { Card, Row, Col } from "react-bootstrap";
import Select from './Form/Select';

export default function CascadeToolToggle(props) {

    const cascadeTypes = [
        {ID: 0, NAME: "Straight"}, 
        {ID: 1, NAME: "Trans"},
        {ID: 5, NAME: "Clean"},
        {ID: 2, NAME: "Gay"},
        {ID: 3, NAME: "Cams"},
        //{ID: 4, NAME: "Blacklist"},
    ]

    return (
        <Card.Header>
            <Row>
                <Col md={8}>
                    <h4 className="title">{props.title}</h4>
                    {props.description && <p className="category">{props.description}</p> }
                </Col>
                <Col md={4} className="text-right">
                    <Select
                        value={props.value}
                        label="Cascade"
                        name="cascadeType"
                        formValues={cascadeTypes}
                        useDefault={false}
                        onChange={props.onChange}
                        validate="numeric|required"
                        colSize="6"
                    />      
                </Col>
            </Row>
        </Card.Header>
    );
}
